// 3rd party imports
import * as React from 'react';

// mobx
import { Program } from 'models';

// ui
import { UitkText } from 'uitk-react-text';
import { ILocalization } from '@shared-ui/localization-context';

export interface ProgramCardLobsProps {
  program: Program;
  l10n: ILocalization;
}

export const ProgramCardLobs: React.FunctionComponent<ProgramCardLobsProps> = ({ program, l10n }) => {
  const lobs = program.lobs.map((lob, index) => {
    return (
      <>
        {index > 0 && <> &middot; </>}
        <span>{l10n.formatText(`programs.cards.lobs.${lob.name}`)}</span>
      </>
    );
  });

  return (
    <UitkText size={200} key="lobns">
      {lobs}
    </UitkText>
  );
};
